export default __webpack_public_path__ + "static/media/notificationFilledIcon.07bb8cef.svg";